"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConclusionAction = exports.AutomationStepExecutionMode = exports.AutomationStepSchedulingMode = exports.AutomationStepTimeDisplayUnit = exports.AutomationOriginator = exports.SystemAutomation = void 0;
var SystemAutomation;
(function (SystemAutomation) {
    SystemAutomation["InterestListAutomation"] = "Interest List Automation";
    SystemAutomation["PreTourAutomation"] = "Pre Tour Automation";
    SystemAutomation["PostTourAutomation"] = "Post Tour Automation";
    SystemAutomation["RentReminderAutomation"] = "Rent Reminder Automation";
    SystemAutomation["ResidentOutreachAutomation"] = "Resident Outreach Automation";
    SystemAutomation["LostLeadAutomation"] = "Lost Lead Automation";
    SystemAutomation["LeaseRenewalAutomation"] = "Lease Renewal Automation";
    SystemAutomation["AppointmentReminderAutomation"] = "Appointment Reminder Automation";
    SystemAutomation["DelinquencyAutomation"] = "Delinquency Automation";
    SystemAutomation["TextOptInAutomation"] = "Text Opt-In Automation";
    SystemAutomation["PreTourVLA"] = "Pre Tour VLA";
    SystemAutomation["PostTourVLA"] = "Post Tour VLA";
})(SystemAutomation = exports.SystemAutomation || (exports.SystemAutomation = {}));
var AutomationOriginator;
(function (AutomationOriginator) {
    AutomationOriginator["System"] = "system";
    AutomationOriginator["User"] = "user";
})(AutomationOriginator = exports.AutomationOriginator || (exports.AutomationOriginator = {}));
var AutomationStepTimeDisplayUnit;
(function (AutomationStepTimeDisplayUnit) {
    AutomationStepTimeDisplayUnit["Hours"] = "hours";
    AutomationStepTimeDisplayUnit["Days"] = "days";
    AutomationStepTimeDisplayUnit["Weeks"] = "weeks";
    AutomationStepTimeDisplayUnit["Months"] = "months";
})(AutomationStepTimeDisplayUnit = exports.AutomationStepTimeDisplayUnit || (exports.AutomationStepTimeDisplayUnit = {}));
// TODO: Eventually we should probably support this at the step level, too.
var AutomationStepSchedulingMode;
(function (AutomationStepSchedulingMode) {
    /**
     * Follow traditional scheduling for automation events
     * (e.g. 10am email, 5:15pm text)
     */
    AutomationStepSchedulingMode["Optimize"] = "optimize";
    /**
     * Immediately schedule an automation event within
     * business hours (M-Su 8am-6pm)
     */
    AutomationStepSchedulingMode["Immediate"] = "immediate";
})(AutomationStepSchedulingMode = exports.AutomationStepSchedulingMode || (exports.AutomationStepSchedulingMode = {}));
// TODO: Eventually we should probably support this at the step level, too.
var AutomationStepExecutionMode;
(function (AutomationStepExecutionMode) {
    /**
     * Each step can only execute after the previous
     * step has been completed (aside from step 1).
     * Starts with the step that has the lowest priority.
     */
    AutomationStepExecutionMode["Chronologically"] = "chronologically";
    /**
     * Steps can execute irrespective of the last
     * step to be executed - but only one step can
     * execute at a time. If multiple steps are found
     * to be elibigle for execution, the step with the
     * highest priority wins.
     */
    AutomationStepExecutionMode["Independently"] = "independently";
})(AutomationStepExecutionMode = exports.AutomationStepExecutionMode || (exports.AutomationStepExecutionMode = {}));
var ConclusionAction;
(function (ConclusionAction) {
    ConclusionAction["MarkLeadAsLost"] = "mark-lead-as-lost";
})(ConclusionAction = exports.ConclusionAction || (exports.ConclusionAction = {}));
